import http from "../plugins/http"

export const fetchModels = async ({ query = "" }: { query?: string } = {}) => {
  const data = await http.get(`/v1/module-parameters/models${query}`)
  return data
}
